export * from './lib/pipes-sanitize-html-pipe.module';
export * from './lib/sanitize-html.util';
